import { useEffect, useState } from 'react';

/**
 * Réponse à une requête média, réévaluée quand elle change.
 *
 * Sert aux différences de **structure** — un formulaire posé en colonne sur grand écran
 * et remonté en feuille depuis le bas sur mobile — que la seule feuille de style ne peut
 * pas produire. Tout ce qui relève de l'apparence reste en CSS : dupliquer un point de
 * rupture entre le style et le code les fait diverger à la première retouche.
 *
 * Renvoie `false` là où `matchMedia` n'existe pas (jsdom sans polyfill) : la variante
 * mobile est la plus contrainte, donc la plus sûre à servir par défaut.
 */
export function useRequeteMedia(requete: string): boolean {
  const [correspond, setCorrespond] = useState(() => evalue(requete));

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const liste = window.matchMedia(requete);
    setCorrespond(liste.matches);

    const surChangement = (evenement: MediaQueryListEvent) => setCorrespond(evenement.matches);
    liste.addEventListener('change', surChangement);
    return () => liste.removeEventListener('change', surChangement);
  }, [requete]);

  return correspond;
}

function evalue(requete: string): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(requete).matches;
}

/** Point de rupture des écrans d'entrée. Doit rester aligné sur `global.css`. */
export const ECRAN_LARGE = '(min-width: 860px)';
